// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-banner-container {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  justify-content: center;
  width: 100%;
  pointer-events: none;
}

.error-banner {
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  max-width: 500px;
  min-width: 320px;
  pointer-events: auto;
  position: relative;
  width: fit-content;
}

.error-left {
  background-color: #f44336;
  padding: 20px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  /* ⬅️ wider red area */
}

.error-svg {
  width: 24px;
  height: 24px;
}

.error-right {
  flex: 1 1;
  padding: 16px 16px 16px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  text-align: left;
  /* ⬅️ ensure left alignment */
}

.error-title {
  font-weight: 600;
  color: #f44336;
  margin-bottom: 4px;
  text-align: left;
  font-size: 15px;
}

.error-message {
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  word-break: break-word;
  text-align: left;
  white-space: pre-wrap;
}

.error-close {
  position: absolute;
  top: 8px;
  right: 8px;
  border: none;
  background: transparent;
  font-size: 18px;
  color: #888;
  cursor: pointer;
  line-height: 1;
}

.error-close:hover {
  color: #f44336;
}`, "",{"version":3,"sources":["webpack://./src/styles/ErrorBanner.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".error-banner-container {\n  position: fixed;\n  bottom: 30px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  pointer-events: none;\n}\n\n.error-banner {\n  display: flex;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  max-width: 500px;\n  min-width: 320px;\n  pointer-events: auto;\n  position: relative;\n  width: fit-content;\n}\n\n.error-left {\n  background-color: #f44336;\n  padding: 20px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  /* ⬅️ wider red area */\n}\n\n.error-svg {\n  width: 24px;\n  height: 24px;\n}\n\n.error-right {\n  flex: 1;\n  padding: 16px 16px 16px 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n  text-align: left;\n  /* ⬅️ ensure left alignment */\n}\n\n.error-title {\n  font-weight: 600;\n  color: #f44336;\n  margin-bottom: 4px;\n  text-align: left;\n  font-size: 15px;\n}\n\n.error-message {\n  font-size: 14px;\n  color: #333;\n  line-height: 1.5;\n  word-break: break-word;\n  text-align: left;\n  white-space: pre-wrap;\n}\n\n.error-close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  border: none;\n  background: transparent;\n  font-size: 18px;\n  color: #888;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.error-close:hover {\n  color: #f44336;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
